// Oil Specific Heat C_o null
// Water Specific Heat C_w null
// Oil Rate q_o bbl/d
// Water Rate q_w bbl/d
// Liquids Rate q_l bbl/d
// Oil Density rho_o lbm/ft^3
// Water Density rho_w lbm/ft^3
// Liquid Density rho_l lbm/ft^3
// returns C_l
export function liquidSpecificHeatCapacityCl(
  oilSpecificHeat: number,
  waterSpecificHeat: number,
  oilFlowRateStbD: number,
  waterFlowRateStbD: number,
  liquidFlowRateStbD: number,
  oilDensityLbFt3: number,
  waterDensityLbFt3: number,
  liquidDensityLbFt3: number
): number {
  return (
    waterSpecificHeat *
      ((waterFlowRateStbD * waterDensityLbFt3) /
        (liquidFlowRateStbD * liquidDensityLbFt3)) +
      oilSpecificHeat *
        ((oilFlowRateStbD * oilDensityLbFt3) /
          (liquidFlowRateStbD * liquidDensityLbFt3)) || 0
  );
}

// Temperature T fahrenheit
// Oil Specific Gravity S_oil API
// returns C_o
export function oilSpecificHeatCapacity(
  tempf: number,
  oilSpGr: number
): number {
  return (
    (-1.39 * Math.pow(10, -6) * tempf + 1.847 * Math.pow(10, -3)) * oilSpGr +
    6.312 * Math.pow(10, -4) * tempf +
    0.35
  );
}

// Temperature T fahrenheit
// returns C_w
export function waterSpecificHeatCapacity(tempf: number): number {
  return 1.0504 - (0.000606 * tempf + 0.00000179 * tempf * tempf);
}
